import * as L from "leaflet";
import RBush from "rbush";
import * as helper from "../utils/helper.js";
import { Node } from "../utils/node.js";
import { ObjectsLinksAndNodes } from "../datadistributor.js";
import { Coords } from "leaflet";
import { nodeIdToStartAngle } from "./clientlayerUtils.js";

export const ClientLayer = L.GridLayer.extend({
  mapRTree: function mapRTree(node: Node) {
    return {
      minX: node.location.latitude,
      minY: node.location.longitude,
      maxX: node.location.latitude,
      maxY: node.location.longitude,
      node: node,
    };
  },
  setData: function (data: ObjectsLinksAndNodes) {
    let rtreeOnlineAll = new RBush(9);

    this.data = rtreeOnlineAll.load(data.nodes.online.filter(helper.hasLocation).map(this.mapRTree));

    // pre-calculate start angles
    this.data.all().forEach(function (positionedNode: { startAngle: number; node: Node }) {
      positionedNode.startAngle = nodeIdToStartAngle(positionedNode.node.node_id);
    });
    this.redraw();
  },
  createTile: function (tilePoint: Coords) {
    const tile = L.DomUtil.create("canvas", "leaflet-tile") as HTMLCanvasElement;

    const tileSize = this.options.tileSize;
    tile.width = tileSize as number;
    tile.height = tileSize as number;

    if (!this.data) {
      return tile;
    }

    const ctx = tile.getContext("2d")!;
    let size = tilePoint.multiplyBy(tileSize);
    let map = this._map;

    let margin = 50;
    let bbox = helper.getTileBBox(size, map, tileSize, margin);

    let nodes = this.data.search(bbox);

    if (nodes.length === 0) {
      return tile;
    }

    let startDistance = 10;

    nodes.forEach(function (node: { node: Node; startAngle: number }) {
      let point = map.project([node.node.location.latitude, node.node.location.longitude]);

      point.x -= size.x;
      point.y -= size.y;

      helper.positionClients(ctx, point, node.startAngle, node.node, startDistance);
    });

    return tile;
  },
});
